import Flex, { FlexProps } from "../../../shared/components/Flex";
import useDevice from "../../../shared/hooks/useDevice";

function InnerFlex({ children, ...props }: FlexProps) {
    const device = useDevice();
    const isMobile = device !== "desktop";
    return (
        <Flex fullWidth flexDirection={isMobile ? "column" : "row"} justifyContent="space-between" alignItems="center" gap={15} {...props}>
            {children}
        </Flex>
  );
}

export default InnerFlex;